export const FETCH_DATA_LIST = {
  links: {
    next: null,
    previous: null
  },
  total: 0,
  pages: 0,
  results: []
}
